<wbo-edit-page #editPage [formGroup]="editPage.formGroup" [title]="title"
               (saving)="saving()">
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.deal.edit.formation.dealDetails',
            formControlNames: ['externalId', 'distributionChannel', 'discount', 'mixAndMatch', 'products']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column formGroupName="distributionChannel">
                        <wbo-text-edit-control formControlName="distributionReference"
                                               [(ngModel)]="model.data.distributionChannel.distributionReference"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column formGroupName="distributionChannel">
                        <wbo-text-edit-control formControlName="distributionType" [readonly]="true"
                                               [(ngModel)]="model.data.distributionChannel.distributionType"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="externalId"
                                               [(ngModel)]="model.data.externalId"></wbo-text-edit-control>
                        <ng-container formGroupName="discount">
                            <wbo-discount-single-select-edit-control formControlName="discountId"
                                                                     [(ngModel)]="model.data.discount.discountId"
                                                                     [objectValue]="model.data.discount"></wbo-discount-single-select-edit-control>
                        </ng-container>
                        <ng-container formGroupName="mixAndMatch">
                            <wbo-mix-and-match-single-select-edit-control formControlName="id"
                                                                          [(ngModel)]="model.data.mixAndMatchId"
                                                                          [objectValue]="model.data.mixAndMatch"></wbo-mix-and-match-single-select-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.products" [editable]="true" [removable]="true"
                                       [entityPath]="'products'" [title]="'wbo.deal.edit.field-set.products'">
                            <wbo-sellable-edit-link-column field="sellable.name" componentPath="sellable"
                                                           [editMode]="EditMode.VIEW" ></wbo-sellable-edit-link-column>
                            <wbo-numeric-column field="quantity" [editable]="true"></wbo-numeric-column>
                            <wbo-edit-grid-add-row [identifierField]="'sellableId'" [componentPath]="'sellable'"
                                                   (onAfterEntityAdded)="afterEntityAdded($event)">
                                <wbo-edit-grid-add-row-quick-add>
                                    <wbo-sellable-single-select-edit-control></wbo-sellable-single-select-edit-control>
                                </wbo-edit-grid-add-row-quick-add>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-search
                                        [title]="'wbo.deal.edit.grid-add.products.addProductLines'"
                                        [searchComponent]="ProductLineSearchPageComponent"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-search
                                        [title]="'wbo.deal.edit.grid-add.products.addCompositeProducts'"
                                        [searchComponent]="CompositeProductSearchPageComponent"></wbo-edit-grid-add-row-search>
                                    <wbo-edit-grid-add-row-new-entity
                                        [title]="'wbo.deal.edit.grid-add.products.newProductLine'"
                                        [editComponent]="ProductLineEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                                    <wbo-edit-grid-add-row-new-entity
                                        [title]="'wbo.deal.edit.grid-add.products.newCompositeProduct'"
                                        [editComponent]="CompositeProductEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.deal.edit.formation.availability',
            formControlNames: ['derivedStatus', 'discontinued', 'app', 'issueDate', 'expiryDate', 'usageLimit', 'usageCount', 'orderAhead', 'orderDelivery', 'orderAtTable', 'scheduleRequired', 'memberNo', 'membershipTypeId', 'schedules']
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="derivedStatus" [readonly]="true"
                                                   [(ngModel)]="model.data.derivedStatus"></wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                                  [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-date-edit-control formControlName="issueDate" [readonly]="true"
                                                   [(ngModel)]="model.data.issueDate"></wbo-date-edit-control>
                            <wbo-date-edit-control formControlName="expiryDate"
                                                   [(ngModel)]="model.data.expiryDate"></wbo-date-edit-control>
                        </fui-tandem-field>
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="usageLimit"
                                                      [(ngModel)]="model.data.usageLimit"></wbo-numeric-edit-control>
                            <wbo-numeric-edit-control formControlName="usageCount"
                                                      [(ngModel)]="model.data.usageCount"></wbo-numeric-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column [label]="'wbo.deal.edit.field-set.orderTypes'">
                        <wbo-checkbox-edit-control formControlName="orderAhead"
                                                   [(ngModel)]="model.data.orderAhead"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="orderDelivery"
                                                   [(ngModel)]="model.data.orderDelivery"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="orderAtTable"
                                                   [(ngModel)]="model.data.orderAtTable"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <ng-container *ngIf="model.data.member?.integratedLoyaltyId">
                            <wbo-text-edit-control formControlName="memberNo"
                                                   [readonly]="true"
                                                   [ngModel]="model.data.member.contact?.firstName + ' ' + model.data.member.contact?.lastName"></wbo-text-edit-control>
                        </ng-container>
                        <ng-container *ngIf="!model.data.member?.integratedLoyaltyId">
                            <wbo-member-no-single-select-edit-control formControlName="memberNo"
                                                                      [(ngModel)]="model.data.memberNo"></wbo-member-no-single-select-edit-control>
                            <wbo-membership-type-multi-select-edit-control formControlName="membershipTypeIds"
                                                                           [includeGuestOption]="true"
                                                                           [(ngModel)]="model.data.membershipTypeIds"></wbo-membership-type-multi-select-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column [label]="'wbo.deal.edit.field-set.scheduling'">
                        <wbo-checkbox-edit-control formControlName="scheduleRequired"
                                                   [(ngModel)]="model.data.scheduleRequired"></wbo-checkbox-edit-control>
                        <wbo-period-schedule-multi-select-edit-control *ngIf="model.data.scheduleRequired"
                                                                       formControlName="periodSchedules"
                                                                       [multiObjectValueType]="true"
                                                                       [(ngModel)]="model.data.periodSchedules"></wbo-period-schedule-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.deal.edit.formation.selectionAndDisplay'
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="selectByDealCodeInApp"
                                                   [(ngModel)]="model.data.selectByDealCodeInApp"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="showAppDealCard"
                                                   [(ngModel)]="model.data.showAppDealCard"></wbo-checkbox-edit-control>
                        <ng-container *ngIf="model.data.showAppDealCard">
                            <wbo-checkbox-edit-control formControlName="featureOnAppMenu"
                                                       [(ngModel)]="model.data.featureOnAppMenu"></wbo-checkbox-edit-control>
                            <ng-container *ngIf="model.data.featureOnAppMenu">
                                <wbo-checkbox-edit-control class="indent" formControlName="suppressDealCardIfAnyOrdered"
                                                           [(ngModel)]="model.data.suppressDealCardIfAnyOrdered"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control class="indent" formControlName="suppressDealCardIfOrdered"
                                                           [readonly]="model.data.suppressDealCardIfAnyOrdered || !model.data.products.length"
                                                           [(ngModel)]="model.data.suppressDealCardIfOrdered"></wbo-checkbox-edit-control>
                            </ng-container>
                        </ng-container>
                    </fui-column>
                    <fui-column *ngIf="model.data.showAppDealCard">
                        <fui-inline-information [title]="'wbo.deal.edit.title.dealCards'"
                                                [message]="'wbo.deal.edit.message.dealCards'">
                        </fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.deal.edit.formation.dealCardContent',
            visible: model.data.showAppDealCard
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="appText1"
                                               [placeholder]="dealTitlePlaceholder"
                                               [(ngModel)]="model.data.appText1"></wbo-text-edit-control>
                        <wbo-text-edit-control formControlName="appText2"
                                               [(ngModel)]="model.data.appText2"></wbo-text-edit-control>
                        <ng-container formGroupName="image">
                            <wbo-image-edit-control formControlName="image" [(ngModel)]="model.data.image.image">
                            </wbo-image-edit-control>
                        </ng-container>
                        <wbo-checkbox-edit-control formControlName="imageAutoCrop"
                                                   [(ngModel)]="model.data.imageAutoCrop"></wbo-checkbox-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="showTitleOnDealCard"
                                                   [(ngModel)]="model.data.showTitleOnDealCard"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control
                                                   formControlName="showAppQrCode"
                                                   [(ngModel)]="model.data.showAppQrCode"></wbo-checkbox-edit-control>
                        <wbo-boolean-radio-edit-control [bordered]="true"
                                                        [trueLabel]="'wbo.deal.edit.field.showActionButtonOnDealCard.true'"
                                                        [falseLabel]="'wbo.deal.edit.field.showActionButtonOnDealCard.false'"
                                                        [(ngModel)]="model.data.showActionButtonOnDealCard"
                                                        formControlName="showActionButtonOnDealCard"></wbo-boolean-radio-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
